import { useLocation, useParams } from "react-router-dom";

import AiCollectionProduct from "./AiCollectionProductScreen/AiCollectionProduct";
import SubCollectionProduct from "./CollectionProductScreen/SubCollectionProduct";
import { useEffect } from "react";
import { useGlobalContext } from "context/GlobalContext";

const CollectionProductPageDynamic = () => {
  const location = useLocation();
  let isAiPage = "";
  const { collectionName } = useParams();
  const { setSearchPlaceHolder } = useGlobalContext();

  const isStockDesign = location?.state?.isStockDesign;
  const isSelectDesign = location?.state?.isSelectDesign;

  const isOutOfStock = location?.state?.isOutOfStock;
  const UnderRatio = location?.state?.UnderRatio;
  const OverRatio = location?.state?.OverRatio;
  const newDesigns = location?.state?.newDesigns;

  useEffect(() => {
    setSearchPlaceHolder("Search By Design Number");
    return () => {
      setSearchPlaceHolder("");
      sessionStorage.setItem("filterChangeCount", 0);
      // sessionStorage.clear();
    };
  }, []);

  const checkAiPageOrNot = () => {
    const decodedCollectionName = decodeURIComponent(collectionName || "");
    const aiPages = ["Top 30 Sold - 30 Days", "Top 60 Sold - 60 Days", "Top 90 Sold - 90 Days", "New 30 Sold - 30 Days", "New 60 Sold - 60 Days", "New 90 Sold - 90 Days", "Only Cad Designs"];

    isAiPage = aiPages.includes(decodedCollectionName);

    return isAiPage;
  };
  if (location.state === null) {
    isAiPage = checkAiPageOrNot();
  } else {
    isAiPage = location?.state?.days > 0 || location?.state?.isCadDesign;
  }

  if (isAiPage || isStockDesign || isSelectDesign || isOutOfStock || UnderRatio || OverRatio || newDesigns) {
    return <AiCollectionProduct />;
  }

  return <SubCollectionProduct />;
};

export default CollectionProductPageDynamic;
